// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { passwordRequirementsValidatorStyles } from "@synd/App/Components/Common/PasswordRequirements";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

passwordRequirementsValidatorStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

passwordRequirementsValidatorStyles.itemContainer = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 12px;
    `,
};

passwordRequirementsValidatorStyles.message = {
    css: css`
        line-height: ${fontConfig.smallSingleLine.lineHeight};
    `,
};

passwordRequirementsValidatorStyles.statusIcon = {
    size: fontConfig.smallSingleLine.size,
    css: css`
        position: relative;
        top: 4px;

        &:not(.password-entered) {
            border: 1px solid ${color("common.border")};
            border-radius: 50%;
            & > svg {
                display: none;
            }
        }
    `,
};
